import { cn } from '~/shared/lib/cn'
import { type IconName, ICONS } from './icons'
import type { Size } from './types'

interface LocalIconProps {
  className?: string
  name: IconName
  size?: Size
}

export function LocalIcon({ className, name, size = '24' }: LocalIconProps) {
  const IconComponent = ICONS[name]

  return (
    <IconComponent
      className={cn('inline-block', className)}
      size={size}
    />
  )
}
